import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import URLSearchParams from 'url-search-params';
import store from 'store2';

import { Provider } from 'react-redux';
import { createDevTools } from 'redux-devtools';
import { compose, createStore, applyMiddleware } from 'redux';
import { responsiveStoreEnhancer } from 'redux-responsive';
import LogMonitor from 'redux-devtools-log-monitor';
import DockMonitor from 'redux-devtools-dock-monitor';
import thunk from 'redux-thunk';
import { BrowserRouter, Route } from 'react-router-dom';
import config from './config';
import Raven from 'raven-js';
import createRavenMiddleware from 'raven-for-redux';

import apiRequestMiddleware from './common/utils/apiRequestMiddleware';
import reducers from './reducers';
import App from './App';
import './index.css';

Raven.config('https://92a5893750ad4428a95c30d6bc8d99a3@sentry.io/233348').install();
Raven.setTagsContext({
  environment: config.sentryEnvironmentTag,
});

// Polyfill URLSearchParams so fetch-client works in IE
window.URLSearchParams = URLSearchParams;

// Apply Redux middleware
let storeEnhancer = compose(
  responsiveStoreEnhancer,
  applyMiddleware(apiRequestMiddleware, thunk, createRavenMiddleware(Raven))
);

// Apply Redux DevTools in development only
let DevTools = null;

if (process.env.NODE_ENV === 'development' && false) {
  DevTools = createDevTools(
    <DockMonitor toggleVisibilityKey="ctrl-h" changePositionKey="ctrl-q" defaultIsVisible={false}>
      <LogMonitor theme="tomorrow" />
    </DockMonitor>
  );

  storeEnhancer = compose(storeEnhancer, DevTools.instrument());
}

// Handle auth tokens from OIDC provider, if set
if (window.location.hash) {
  // Parse URL hash of format #foo=bar&stuff=things
  const hashQuery = window.location.hash
    .substring(1)
    .split('&')
    .map(str => str.split('='))
    .reduce((prev, curr) => {
      prev[curr[0]] = curr[1];
      return prev;
    }, {});

  // nonce is only set when frontend requests login/registration
  const nonce = store.get('nonce');

  if (hashQuery.id_token && nonce) {
    let decoded = JSON.parse(atob(hashQuery.id_token.split('.')[1]));

    Raven.setUserContext({
      id: decoded.sub,
    });

    if (nonce === decoded.nonce) {
      store.set('code', hashQuery.code);
      store.set('idToken', hashQuery.id_token);
      store.remove('nonce');
    }
  }

  // Remove URL hash while maintaining history and query string
  history.replaceState('', document.title, window.location.pathname + window.location.search);
}

// Bootstrap the React app
const reduxStore = storeEnhancer(createStore)(reducers);
ReactDOM.render(
  <Provider store={reduxStore}>
    <BrowserRouter>
      <div>
        <Route component={App} />
        <Route component={DevTools} />
      </div>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js